import { render, staticRenderFns } from "./Lgx243856109283475621.vue?vue&type=template&id=32167f74&scoped=true&"
import script from "./Lgx243856109283475621.vue?vue&type=script&lang=js&"
export * from "./Lgx243856109283475621.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243856109283475621.vue?vue&type=style&index=0&id=32167f74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32167f74",
  null
  
)

export default component.exports